var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2365 0.202524L5.49952 7.40189L0.762546 0.202524C0.677912 0.0736349 0.564298 0.0014776 0.44599 0.0014776C0.327682 0.0014776 0.214068 0.0736349 0.129434 0.202524C0.0884543 0.265125 0.0558984 0.339846 0.0336731 0.422311C0.0114478 0.504776 0 0.593327 0 0.682777C0 0.772226 0.0114478 0.860777 0.0336731 0.943242C0.0558984 1.02571 0.0884543 1.10043 0.129434 1.16303L5.16874 8.82344C5.25724 8.95793 5.37593 9.0332 5.49952 9.0332C5.6231 9.0332 5.74179 8.95793 5.83029 8.82344L10.8696 1.16451C10.9109 1.10186 10.9437 1.02695 10.9661 0.944216C10.9885 0.861478 11 0.772582 11 0.682777C11 0.592971 10.9885 0.504075 10.9661 0.421337C10.9437 0.338598 10.9109 0.263694 10.8696 0.201045C10.785 0.0721565 10.6713 0 10.553 0C10.4347 0 10.3211 0.0721565 10.2365 0.201045V0.202524Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.387dccac499aa6d7d141fb350911a24d.svg";
export { ForwardRef as ReactComponent };